import {
  AfterContentInit,
  Component,
  ContentChildren,
  Input,
  OnChanges,
  OnInit,
  QueryList,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { TablaTemplateDirective } from '../../directives/template.directive';
import { DataTableDirective } from 'angular-datatables';

@Component({
  selector: 'app-tabla',
  templateUrl: './tabla.component.html',
  styleUrls: ['./tabla.component.css']
})
export class TablaComponent implements AfterContentInit {
  @ContentChildren(TablaTemplateDirective)
  templates?: QueryList<TablaTemplateDirective>; // Obtenemos los TemplateDirective renderizados en el dom
  @ViewChild(DataTableDirective, { static: false })
  datatableElement?: DataTableDirective;
  @Input() dtOptions?: DataTables.Settings;
  @Input() data?: any[];

  headerTemplate?: TemplateRef<any>;
  bodyTemplate?: TemplateRef<any>;

  constructor() {}

  ngOnChange(): void {}

  ngAfterContentInit(): void {
    this.templates!.forEach(item => {
      switch (item.getType()) {
        case 'header':
          this.headerTemplate = item.template;
          break;
        case 'body':
          this.bodyTemplate = item.template;
          break;
        default:
          break;
      }
    });
  }

  onFiltrar() {
    this.datatableElement!.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
    });
  }
}
